<template>
  <div class="resume-detail">
    <div class="title">
      <div class="label">销假</div>
      <div class="content"></div>
    </div>

    <div class="item">
      <div class="label">返校时间：</div>
      <div class="content">{{ detail.backTime }}</div>
    </div>

    <div class="item">
      <div class="label">是否到校：</div>
      <div class="content">{{ detail.isBack ? "是" : "否" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return {}
      }
    }
  }
};
</script>

<style lang="less" scoped>
.resume-detail {
  font-size: 15px;
  font-weight: 400;
  padding: 12px;
  margin-top: 10px;
  border-radius: 8px;
  background-color: #fff;
  .title {
    display: flex;
    height: 44px;
    margin-bottom: 12px;
    .label {
      flex: 1;
    }
    .content {
      flex: 2;
    }
  }
  .item {
    display: flex;
    height: 44px;
    .label {
      flex: 1;
      color: #666;
    }
    .content {
      flex: 2;
      color: #333;
      text-align: right;
    }
  }
}
</style>
